import script from "./landingErp.vue?vue&type=script&setup=true&lang=js"
export * from "./landingErp.vue?vue&type=script&setup=true&lang=js"

import "./landingErp.vue?vue&type=style&index=0&id=afcbb698&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afcbb698"]])

export default __exports__